import $ from 'jquery';
import anime from 'animejs';
import {initSlider} from '../routes/home';
// import fullpage from 'fullpage.js';
import {ChangeLogoColour} from '../routes/common';

export const menuAnimation = function () {
  $('.nav').toggleClass('is-active');
  $('header').removeClass('is-light');
  if ($('body').hasClass('menu-is-active')) {
    $('.toggle-menu').html('menu').removeClass('is-active');
    if ($('body').hasClass('home')) {
      initSlider();
      ChangeLogoColour();
    }
    $('body').removeClass('menu-is-active');
    $('.menu-item-image').removeClass('has-hover-state');
    anime({
      targets: '.nav',
      width: '0%',
      duration: 50,
      easing: 'linear',
      complete: function () {
        anime({
          targets: '.nav',
          left: '0',
          duration: 50,
          easing: 'easeInOutBack',
          complete: function () {
            anime({
              targets: '.nav ul li a',
              opacity: 0,
              translateY: ['0', '30px'],
              duration: 50,
            });
          },
        });
      },
    });
  } else {
    $('.toggle-menu').html('close').addClass('is-active');
    if ($('body').hasClass('home')) {
      fullpage_api.destroy('all'); // eslint-disable-line
    }
    $('body').addClass('menu-is-active');
    if ($(window).width() <= 770) {
      anime({
        targets: '.nav',
        left: '0',
        duration: 1,
        easing: 'linear',
        complete: function () {
          anime({
            targets: '.nav',
            width: '100%',
            duration: 250,
            easing: 'easeInOutQuad',
            complete: function () {
              anime({
                targets: '.nav ul li a',
                opacity: 1,
                translateY: ['30px', '0'],
                duration: 1000,
                delay: anime.stagger(100),
                easing: 'easeInOutBack',
              });
            },
          });
        },
      });
    } else {
      anime({
        targets: '.nav',
        left: '100px',
        duration: 1,
        easing: 'linear',
        complete: function () {
          anime({
            targets: '.nav',
            width: '100%',
            duration: 250,
            easing: 'easeInOutQuad',
            complete: function () {
              anime({
                targets: '.nav ul li a',
                opacity: 1,
                translateY: ['30px', '0'],
                duration: 1000,
                delay: anime.stagger(100),
                easing: 'easeInOutBack',
              });
            },
          });
        },
      });
    }
  }

};
